import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonPopoverContent } from '../Popover/PopoverContent/PopoverContent.definition';
import { chameleonTooltipV2 } from './TooltipV2.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTooltipV2({ prefix }), chameleonPopoverContent({ prefix }));
}
